import React from 'react';
import PhoneIcon from '@mui/icons-material/Phone';
import SecurityIcon from '@mui/icons-material/Security';
import './Security.css';

const Security = () => {
  const emergencyContacts = [
    { name: 'Emergencias', number: '911' },
    { name: 'Cruz Roja SLP', number: '(444) 815 0519' },
    { name: 'Bomberos SLP', number: '(444) 815 8090' },
    { name: 'Protección Civil Municipal', number: '(444) 815 8767' },
    { name: 'Protección Civil Estatal', number: '(444) 833 7338' },
    { name: 'Denuncia Anónima', number: '089' },
    { name: 'Comisión Federal de Electricidad (CFE)', number: '071' },
  ];

  const securityProcedures = [
    'En caso de incendio, usa las salidas de emergencia y evita el elevador.',
    'Si hay un sismo, colócate en una zona segura y sigue las indicaciones del personal del edificio.',
    'En caso de emergencia médica, contacta al 911 y proporciona la dirección del departamento.',
    'El acceso al edificio está restringido; no permitas la entrada de desconocidos.',
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Seguridad y Emergencias</h1>
        <p className="page-intro">
          Aquí encontrarás información sobre seguridad y contactos de emergencia.
        </p>
      </div>

      <div className="page-content">
        <section className="page-section section-gradient-left">
          <div className="section-header">
            <PhoneIcon sx={{ fontSize: 32, color: '#606C38' }} />
            <h2>Contactos de Emergencia</h2>
          </div>
          <div className="contacts-list">
            {emergencyContacts.map((contact, index) => (
              <div key={index} className="contact-item">
                <span className="contact-name">{contact.name}</span>
                <a 
                  href={`tel:${contact.number.replace(/\D/g, '')}`}
                  className="contact-number"
                >
                  {contact.number}
                </a>
              </div>
            ))}
          </div>
        </section>

        <section className="page-section section-gradient-right">
          <div className="section-header">
            <SecurityIcon sx={{ fontSize: 32, color: '#606C38' }} />
            <h2>Procedimientos de Seguridad</h2>
          </div>
          <div className="procedures-list">
            {securityProcedures.map((procedure, index) => (
              <div key={index} className="procedure-item">
                <span className="procedure-number">{index + 1}</span>
                <p className="procedure-text">{procedure}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Security; 